import { LogLevel } from "@azure/msal-browser";
import {CONFIG} from "./config";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
const tenant = CONFIG.REACT_APP_AUTH_TENANT;

const getAuthorinty = (policy) => {
  return `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/${policy}`;
};

export const b2cPolicies = {
  names: {
    signIn: CONFIG.REACT_APP_AUTH_SIGNIN_NAME,
    signUp: CONFIG.REACT_APP_AUTH_SIGNUP_NAME,
    forgotPassword: CONFIG.REACT_APP_AUTH_SIGNIN_NAME,
    editProfile: CONFIG.REACT_APP_AUTH_PROFILEEDIT_NAME,
  },
  authorities: {
    signIn: {
      authority: getAuthorinty(CONFIG.REACT_APP_AUTH_SIGNIN_NAME),
      // "https://humaniaassurancedev.b2clogin.com/humaniaassurancedev.onmicrosoft.com/b2c_1a_signinonly",
    },
    signUp: {
      authority: getAuthorinty(CONFIG.REACT_APP_AUTH_SIGNUP_NAME),
      // "https://humaniaassurancedev.b2clogin.com/humaniaassurancedev.onmicrosoft.com/b2c_1a_signuponly",
    },
    forgotPassword: {
      authority: getAuthorinty(CONFIG.REACT_APP_AUTH_SIGNIN_NAME),
      // "https://humaniaassurancedev.b2clogin.com/humaniaassurancedev.onmicrosoft.com/b2c_1a_signinonly",
    },
    editProfile: {
      authority: getAuthorinty(CONFIG.REACT_APP_AUTH_PROFILEEDIT_NAME),
    },
  },
  authorityDomain: `${tenant}.b2clogin.com`, // "humaniaassurancedev.b2clogin.com",
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
//console.log('CONFIG.REACT_APP_AUTH_REDIRECTURL', CONFIG.REACT_APP_AUTH_REDIRECTURL);
export const msalConfig = {
  auth: {
    clientId: CONFIG.REACT_APP_AUTH_CLIENTID, // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signIn.authority, // Choose SIGNINONLY as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: CONFIG.REACT_APP_AUTH_REDIRECTURL, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: CONFIG.REACT_APP_AUTH_POSTLOGOUTURL, // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  system: {
    pkce: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
          //  console.error(message);
            break;
          case LogLevel.Info:
        //    console.info(message);
            break;
          case LogLevel.Verbose:
          //  console.debug(message);
            break;
          case LogLevel.Warning:
          //  console.warn(message);
            break;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Verbose,
    },
  },
  cache: {
    cacheLocation: "localStorage", // Keeping localStorage to match your old config
    storeAuthStateInCookie: false, // Same as your old config
  },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  api: {
    endpoint: CONFIG.REACT_APP_SERVER,
    scopes: {
      read: [
        //"https://humaniaassurancedev.onmicrosoft.com/e4601e53-b310-4bc1-861f-b0285e0120eb/ScopeRead",
        CONFIG.REACT_APP_AUTH_ENDPOINTREADSCOPE,
      ],
      write: [
        //"https://humaniaassurancedev.onmicrosoft.com/e4601e53-b310-4bc1-861f-b0285e0120eb/ScopeRead",
        CONFIG.REACT_APP_AUTH_ENDPOINTWRITESCOPE,
      ],
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes

 export const loginRequest = {
 scopes: [
 ...protectedResources.api.scopes.read,
 ...protectedResources.api.scopes.write,
 ],
 };
 */
export const loginRequest = {
  scopes: [
    "openid",
    "profile",
   // CONFIG.REACT_APP_AUTH_ENDPOINTREADSCOPE,
   // CONFIG.REACT_APP_AUTH_ENDPOINTWRITESCOPE,
  ],
};